export class Unauthorized extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'UnauthorizedError';
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, Unauthorized);
    }
  }
}
